import { Textarea } from "@chakra-ui/react";
import { Modal } from "antd";
import colors from "core/resources/theme/colors";
import React, { useState } from "react";
import { useEffect } from "react";
import FooterModal from "ui/components/Button/FooterModal";

interface ModalRejeitarMotivoProps {
  visible: boolean;
  onClose: () => any;
  onSubmit: (motivo: string) => any;
  isLoadingSave: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

function ModalRejeitarMotivo({
  visible,
  onClose,
  onSubmit,
  isLoadingSave,
  primaryButtonText = "Rejeitar",
  secondaryButtonText = "Cancelar",
}: ModalRejeitarMotivoProps) {
  const [motivo, setMotivo] = useState("");

  useEffect(() => {
    setMotivo("");
  }, [visible]);

  return (
    <Modal
      destroyOnClose
      width="600px"
      title="Motivo"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={() => onSubmit(motivo)}
          onClose={onClose}
          isLoadingSave={isLoadingSave}
          isDisabled={isLoadingSave || !motivo}
          showRegisterAnother={false}
          primaryButtonText={primaryButtonText}
          buttonCancelarText={secondaryButtonText}
          primaryButtonBgColor={colors.red}
        />
      }
      centered
      bodyStyle={{
        height: "fit-content",
        overflow: "auto",
      }}
      visible={visible}
      onCancel={onClose}
    >
      <Textarea
        className="chakra-input"
        rows={10}
        value={motivo}
        onChange={(ev) => setMotivo(ev.target.value)}
      />
    </Modal>
  );
}

export default ModalRejeitarMotivo;
